import { render, staticRenderFns } from "./RealEstatePortal.vue?vue&type=template&id=7c5ba483"
import script from "./RealEstatePortal.vue?vue&type=script&lang=js"
export * from "./RealEstatePortal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports